import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBusyIndicator } from "../contexts/BusyIndicatorContext";
import { useError } from "../contexts/ErrorContext";

export default function RouteLifecycle() {
  const location = useLocation();
  const { closeAllBusyIndicators } = useBusyIndicator();
  const { closeError } = useError();

  useEffect(() => {
    closeError();
    closeAllBusyIndicators();
  }, [location.pathname, location.search, closeError, closeAllBusyIndicators]);

  return null;
}
